// utils/pdfExport.js
import jsPDF from 'jspdf'
import { autoTable } from 'jspdf-autotable'
import { beginSensitiveEgress } from '@/utils/demoEgress'

export function generatePdf({
  rowData,
  columns,
  groupHeaders = null,
  logoUrl = '',
  title = 'Patient List',
  filename = 'table.pdf',
  orientation = 'l',
  fontSize = 8,  // Add this parameter with default value
  headerFontSize = null,  // Optional separate header font size
  titleFontSize = 14  // Optional title font size
}) {
  const ticket = beginSensitiveEgress('export')
  if (!ticket) return null
  const doc = new jsPDF(orientation, 'pt')

  const addTable = () => {
    const columnsConfig = columns.map(col => ({
      header: col.header,
      dataKey: col.dataKey
    }))

    const head = [
      groupHeaders?.map(group => ({
        content: group.header,
        colspan: group.colspan || 1
      })),
      columnsConfig.map(col => col.header)
    ]

    const columnStyles = {}
    columns.forEach(col => {
      if (col.width) {
        columnStyles[col.dataKey] = { cellWidth: col.width }
      }
    })

    autoTable(doc, {
      startY: logoUrl ? 100 : 60,
      head: groupHeaders ? head : [columnsConfig.map(col => col.header)],
      columns: columnsConfig,
      body: rowData,
      styles: {
        font: 'Helvetica',
        fontSize: fontSize,  // Use the parameter here
        textColor: [0, 0, 0],
        cellPadding: fontSize <= 7 ? 1.5 : 2  // Reduce padding for smaller fonts
      },
      headStyles: {
        fillColor: [38, 135, 44],
        textColor: [255, 255, 255],
        halign: 'center',
        fontSize: headerFontSize || fontSize  // Allow different header size
      },
      columnStyles: columnStyles,
      didDrawPage: () => {
        doc.setFontSize(12)
      },
      margin: { top: 40 }
    })

    if (!ticket.confirm()) return
    doc.save(filename)
  }

  if (logoUrl) {
    const img = new Image()
    img.src = logoUrl
    img.onload = () => {
      doc.addImage(img, 'PNG', 40, 40, 100, 50)
      doc.setFontSize(titleFontSize)  // Use the parameter for title
      doc.text(title, 150, 70)
      addTable()
    }
  } else {
    doc.setFontSize(titleFontSize + 4)  // Slightly larger when no logo
    doc.text(title, 40, 50)
    addTable()
  }
}
